import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, ICardReplaceDtoReasonEnum } from '@/dtos';
import { ReplacementInitiationType } from '@/modules/transaction/Cards/Cards.types';

export interface ReplacementCardData {
  reason?: ICardReplaceDtoReasonEnum;
  replacement_initiation_type?: ReplacementInitiationType;
  // address_line1: string,
  // address_line2: string,
  // city: string,
  // state: string,
  // zip: string,
}

interface ReplacementRequestCardData {
  cardID: string;
  replacementInitiationType?: ReplacementInitiationType;
  data: ReplacementCardData;
}

export default () => {
  const { mutateAsync, isLoading } = useMutation((value: ReplacementRequestCardData) =>
    api.post(API_URL.CARDS_REPLACEMENT_BY_CARD_ID(value.cardID), {
      ...value?.data,
      replacement_initiation_type: value?.replacementInitiationType,
    })
  );

  const handleSave = async (data: ReplacementRequestCardData) => {
    await mutateAsync(data);
  };

  return {
    onSave: handleSave,
    isLoading,
  };
};
